export default Object.freeze({
  BlockUsage: 1,
  AllowWithWarning: 2,
});
